import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';

export const DEFAULT_SESSION_TIMEOUT = 1800000; // 30 min in ms
export const DEFAULT_MSG_SHOW_DELAY = 300000; // 5 minutes in ms

@Injectable({
  providedIn: 'root'
})
export class SessionTimerService {
  public initTimer(sessionTimeOut: number = 0, sessionTimeoutMsgShowDelay: number = DEFAULT_MSG_SHOW_DELAY): Observable<number> {
    const timeout = sessionTimeOut === 0 ? DEFAULT_SESSION_TIMEOUT : sessionTimeOut;
    return timer(timeout - sessionTimeoutMsgShowDelay);
  }

  public initMsgShowTimer(sessionTimeoutMsgShowDelay: number = DEFAULT_MSG_SHOW_DELAY): Observable<number> {
    return timer(sessionTimeoutMsgShowDelay);
  }
}
